// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer-section {
  position: fixed;
  text-align: center;
  bottom: 4px !important;
  width: 100%;
}

.bottom_line {
  box-shadow: none !important;
}

.Sign {
  margin-top: 18px;
}

.font-text-color {
  color: var(--ion-header-text) !important;
}`, "",{"version":3,"sources":["webpack://./src/app/authentication/forgot-password/forgot-password.page.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,kBAAA;EACA,sBAAA;EACA,WAAA;AACF;;AACA;EACE,2BAAA;AAEF;;AAAA;EACE,gBAAA;AAGF;;AADA;EACE,wCAAA;AAIF","sourcesContent":[".footer-section {\n  position: fixed;\n  text-align: center;\n  bottom: 4px !important;\n  width: 100%;\n}\n.bottom_line {\n  box-shadow: none !important;\n}\n.Sign {\n  margin-top: 18px;\n}\n.font-text-color {\n  color: var(--ion-header-text) !important;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
